export * from './simple-pager/simple-pager.module';
export * from './simple-pager/simple-pager.component';
